import React from 'react';

import { Column, Row } from 'app/shopify/components/layout';

import { Image } from './Image';

export function ImageShowcase() {
  return (
    <Column gap="spacing.general.x3" padding="spacing.general.x4">
      <Row gap="spacing.general.x3">
        <Image aspectRatio="1:1" orientation="landscape" />
        <Image aspectRatio="7:5" orientation="landscape" />
      </Row>

      <Row gap="spacing.general.x3">
        <Image aspectRatio="7:5" orientation="portrait" />
        <Image aspectRatio="16:9" orientation="landscape" />
      </Row>

      <Row gap="spacing.general.x3">
        <Image aspectRatio="2:3" orientation="landscape" />
        <Image aspectRatio="16:9" orientation="portrait" />
      </Row>
    </Column>
  );
}
